export class revealOnScrollModule {
	revealItem: NodeList = document.querySelectorAll("[data-reveal]");
	revealItems: HTMLElement[] = Array.prototype.slice.call(this.revealItem);
	isVisibleClass: string = "is-visible";

	constructor() {
		this.inViewCheck();
		window.addEventListener("scroll", this.inViewCheck, false);
		window.addEventListener("resize", this.inViewCheck, false);
	}
	private inViewCheck = () => {
		let windowHeight: number = window.innerHeight;
		let windowScrollPosition: number = window.pageYOffset || document.documentElement.scrollTop;
		// get window height, top and bottom
		let windowBottomPosition: number = (windowScrollPosition + windowHeight);

		// loop over all elemntes.
		this.revealItems.forEach((element: HTMLElement) => {
			// get elements height, top and bottom positioning
			let elementHeight: number = element.offsetHeight;
			let elementTopPosition: number = element.offsetTop;
			let elementBottomPosition: number = (elementTopPosition + elementHeight);

			if ((elementBottomPosition >= windowScrollPosition) &&
				(elementTopPosition <= windowBottomPosition)) {
				// add class if element is in viewport
				element.classList.add(this.isVisibleClass);
			}
		});
	}
}



